/* Native GET filters remain the source of truth; enhancement changes presentation only. */
(() => {
  if (window.cpCollectionLayoutReady) return;
  window.cpCollectionLayoutReady = true;
  const mounted = new Map();
  function mount(root) {
    root.querySelectorAll('[data-collection-controls]').forEach(form => {
      if (mounted.has(form)) return;
      const events = new AbortController();
      const options = { signal: events.signal };
      const select = form.querySelector('[data-collection-sort]');
      const apply = form.querySelector('[data-sort-apply]');
      const dialog = form.querySelector('[data-filter-dialog]');
      const disclosure = form.querySelector('[data-filter-disclosure]');
      const trigger = form.querySelector('[data-filter-trigger]');
      const panel = form.querySelector('[data-filter-panel]');
      const reset = form.querySelector('[data-filter-reset]');
      const close = form.querySelector('[data-filter-close]');
      const ranges = Array.from(form.querySelectorAll('[data-filter-range]'));
      let draft = [], overflow = null, submitting = false;
      const filterInputs = () => Array.from(panel?.querySelectorAll('input') || []);
      const canDialog = dialog && typeof dialog.showModal === 'function';
      const unlock = () => {
        if (overflow !== null) { document.documentElement.style.overflow = overflow; overflow = null; }
      };
      function updateSelection() {
        if (!panel) return;
        const count = filterInputs().filter(input => input.type === 'checkbox' && input.checked).length + ranges.filter(range => Array.from(range.querySelectorAll('input')).some(input => input.value !== '')).length;
        panel.querySelector('[data-filter-selection]').textContent = count ? `${count} ${count === 1 ? 'selection' : 'selections'} · Apply to update results` : 'All pieces · No filters selected';
        ranges.forEach(range => {
          const min = range.querySelector('[data-price-min]');
          const max = range.querySelector('[data-price-max]');
          const invalid = min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value);
          max.setCustomValidity(invalid ? 'Maximum price must be at least the minimum price.' : '');
          range.querySelector('[data-price-error]').hidden = !invalid;
        });
      }
      if (canDialog) {
        dialog.append(panel);
        disclosure.removeAttribute('open');
        disclosure.setAttribute('data-filter-enhanced', '');
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', dialog.id);
        trigger.setAttribute('aria-expanded', 'false');
        close.hidden = false;
        reset.hidden = false;
        panel.querySelector('[data-filter-clear]').hidden = true;
        trigger.addEventListener('click', event => {
          event.preventDefault();
          if (dialog.open) return;
          draft = filterInputs().map(input => ({ input, value: input.value, checked: input.checked }));
          submitting = false;
          updateSelection();
          dialog.showModal();
          overflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          trigger.setAttribute('aria-expanded', 'true');
          close.focus({ preventScroll: true });
        }, options);
        close.addEventListener('click', () => dialog.close(), options);
        let backdropPress = false;
        dialog.addEventListener('pointerdown', event => { backdropPress = event.target === dialog; }, options);
        dialog.addEventListener('click', event => { if (event.target === dialog && backdropPress) dialog.close(); backdropPress = false; }, options);
        dialog.addEventListener('close', () => {
          if (!submitting) draft.forEach(({ input, value, checked }) => { input.value = value; input.checked = checked; });
          updateSelection();
          unlock();
          trigger.setAttribute('aria-expanded', 'false');
          if (trigger.isConnected) trigger.focus({ preventScroll: true });
        }, options);
        reset.addEventListener('click', () => {
          filterInputs().forEach(input => { if (input.type === 'checkbox') input.checked = false; else input.value = ''; });
          updateSelection();
        }, options);
      }
      panel?.addEventListener('input', updateSelection, options);
      panel?.addEventListener('change', updateSelection, options);
      if (select && apply && typeof form.requestSubmit === 'function') {
        apply.hidden = true;
        select.addEventListener('change', () => form.requestSubmit(), options);
      }
      // Empty price bounds must not be submitted as an accidental zero limit.
      form.addEventListener('formdata', event => {
        filterInputs().filter(input => input.type === 'number' && input.value === '').forEach(input => event.formData.delete(input.name));
      }, options);
      form.addEventListener('submit', () => { submitting = true; }, options);
      // A preview link should keep using the selected draft after sorting/filtering.
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) {
        const input = document.createElement('input'); input.type = 'hidden'; input.name = 'preview_theme_id'; input.value = preview; form.append(input);
      }
      window.addEventListener('pageshow', () => { submitting = false; if (!dialog?.open) unlock(); }, options);
      mounted.set(form, () => {
        if (dialog?.open) dialog.close();
        unlock(); events.abort(); mounted.delete(form);
      });
    });
  }
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [form, cleanup] of mounted) if (event.target.contains(form)) cleanup();
  });
})();
